/* @flow */

import renderMain from './render-main';
import renderTopBar from '../TopBar/render-top-bar';

const renderPreactApp = () => {
    renderMain();
    renderTopBar();
};

export default renderPreactApp;
